export const TableMessage = ({ children, colSpan }) => (
  <tr>
    <td className="text-muted" colSpan={colSpan}>
      {children}
    </td>
  </tr>
);

export const Message = ({ children }) => (
  <div className="d-flex justify-content-center align-items-center w-100 h-100 text-muted">
    {children}
  </div>
);
